import Image from 'next/image';
import React from 'react';
import { getLocalizedPath } from '../../../shared/formatURL';
import Link from 'next/link';

interface Post {
  _id: string;
  author: string;
  createdAt: string;
  imageUrl: string;
  likes: number;
  model: string;
  tagGroups: string[];
  updatedAt: string;
  userLiked: boolean;
  views: number;
}

interface PictureCardProps {
  data: Post;
}

const PictureCard: React.FC<PictureCardProps> = ({ data }) => {
  const { _id, imageUrl } = data;

  const newURL = getLocalizedPath('post/' + _id);

  return (
    <>
      <div className="relative bg-[#2B2D31] shadow-sm sm:rounded-md">
        {/* <Link href={newURL}> */}
        <Image
          className="border-[0.0px] border-[#3C3C3C] shadow sm:rounded-md"
          src={imageUrl}
          alt={_id}
          layout="responsive"
          width={2}
          height={3}
          unoptimized
        />
        {/* </Link> */}
      </div>
    </>
  );
};

export default PictureCard;
